import { Component } from "@angular/core";
import { APP_PAGES } from "src/app/app.component";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-home",
  templateUrl: "./home.page.html",
  styleUrls: ["./home.page.scss"],
})
export class HomePage {
  VERSION = environment.VERSION;
  pages = APP_PAGES;
  stagingSite: boolean;
  constructor() {
    this.stagingSite = !environment.production;
  }
}
